// extracted by mini-css-extract-plugin
export var pillWrapper = "_x6-0";
export var showOverflow = "_x6-1";